import { render } from "./TableBody.vue?vue&type=template&id=e91c77cc"
import script from "./TableBody.vue?vue&type=script&lang=js"
export * from "./TableBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Tables/TableBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e91c77cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e91c77cc', __exports__)) {
    api.reload('e91c77cc', __exports__)
  }
  
  module.hot.accept("./TableBody.vue?vue&type=template&id=e91c77cc", () => {
    api.rerender('e91c77cc', render)
  })

}


export default __exports__